import React from "react";
import PrimaryButtonPageLevel from "../../components/button/primary-button/PrimaryButtonLevelPage";
import { getConstantStringByLanguage } from "../../templates/helper/getConstantStringByLanguage";
import ConstantStrings from "../../constants/ConstantStrings";

const ResultPayment = ({handleChangeShowPhone}) => {
  return (
    <div
      className="is-flex is-flex-direction-column is-align-items-center is-justify-content-center"
      style={{ gap: "2.5rem", height: "30rem" }}
    >
      <div>
        <p className="has-text-kurio-main-color-black has-text-weight-normal has-text-centered" style={{fontSize:"1.125rem"}}>
          {getConstantStringByLanguage(ConstantStrings.CONTACT_SUPPORT_FOR_VIP_UPGRADE)}
        </p>
      </div>
      <div className="is-flex is-flex-direction-column" style={{ gap: "1rem" }}>
        <PrimaryButtonPageLevel
        onClick={()=>handleChangeShowPhone(true)}
          style={{ height: "4rem", borderRadius: "1rem" }}
        >
          {getConstantStringByLanguage(ConstantStrings.CALL)}
        </PrimaryButtonPageLevel>
        <PrimaryButtonPageLevel
        onClick={()=>handleChangeShowPhone(true)}
          style={{ height: "4rem", borderRadius: "1rem" }}
        >
          Chat Zalo
        </PrimaryButtonPageLevel>
      </div>
    </div>
  );
};

export default ResultPayment;
